import '@hotmart/cosmos/dist/tooltip'
import { CommentSuggestionSkeletonProps } from './commentSuggestionSkeleton.types'
import { Option, Wrapper } from './commentSuggestionSkeleton.styles'

const CommentSuggestionSkeleton = ({ length = 1 }: CommentSuggestionSkeletonProps) => {
  return (
    <Wrapper className="_d-flex" role="status" aria-busy="true">
      {Array.from({ length }, (_, index) => (
        <Option key={index} className="_border _border-gray-200 _rounded-pill" />
      ))}
    </Wrapper>
  )
}

export default CommentSuggestionSkeleton
